// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3NHqr","addWidgetButton":"Header_addWidgetButton__3kcl5","dashboardTabs":"Header_dashboardTabs__2SuTk","active":"Header_active__25u9M"};